export var Filters;
(function (Filters) {
    Filters["CATEGORY"] = "category";
    Filters["SEGMENT"] = "segment";
    Filters["MODEL"] = "model";
    Filters["YEAR"] = "year";
    Filters["LANGUAGE"] = "language";
})(Filters || (Filters = {}));
